import { render, staticRenderFns } from "./PricesRangeList.vue?vue&type=template&id=c48230d8&scoped=true&"
import script from "./PricesRangeList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PricesRangeList.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PricesRangeList.vue?vue&type=style&index=0&id=c48230d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48230d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c48230d8')) {
      api.createRecord('c48230d8', component.options)
    } else {
      api.reload('c48230d8', component.options)
    }
    module.hot.accept("./PricesRangeList.vue?vue&type=template&id=c48230d8&scoped=true&", function () {
      api.rerender('c48230d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/components/PricesRangeList.vue"
export default component.exports